import styled from '@emotion/styled';
import { Button } from 'antd';
import { useGetCustomStyles } from 'api/hooks';
import * as React from 'react';
import { colors } from 'styles/colors';
import './SoloButton.css';

type SoloButtonBlockProps = {
  isCancel?: boolean;
  isNegative?: boolean;
  primaryColorOverride?: string;
};

export const SoloButtonBlock = styled.div`
  position: relative;
  display: inline-block;
  text-align: center;

  button.ant-btn {
    padding: 10px 20px;
    font-size: 16px;
    line-height: 14px;
    background: ${(props: SoloButtonBlockProps) => props.primaryColorOverride || colors.seaBlue};
    color: white;
    border: none;
    outline: none;
    border-radius: 8px;
    min-width: 125px;
    height: auto;
    cursor: pointer;

    &:hover,
    &:focus {
      color: white;
      background: ${colors.lakeBlue};
    }

    &:active {
      background: ${colors.seaBlue};
    }

    &:disabled {
      opacity: 0.3;
      pointer-events: none;
      cursor: default;
      background: ${colors.seaBlue};
      color: white;
    }

    > span {
      position: relative;
      z-index: 2;
    }

    ${(props: SoloButtonBlockProps) =>
      !!props.isCancel
        ? `background: ${colors.juneGrey};

  &:hover,
  &:focus {
    background: ${colors.mayGrey};
  }

  &:active {
    background: ${colors.juneGrey};
  }

  &:disabled {
    background: ${colors.juneGrey};
  }`
        : !!props.isNegative
        ? `background: ${colors.grapefruitOrange};

  &:hover,
  &:focus {
    background: ${colors.peachOrange};
  }

  &:active {
    background: ${colors.grapefruitOrange};
  }

  &:disabled {
    background: ${colors.grapefruitOrange};
  }`
        : ''};
  }
`;

interface ButtonProps {
  text: string;
  onClick: (e: React.MouseEvent<any, MouseEvent>) => void;
  errorText?: string;
  error?: boolean;
  disabled?: boolean;
  isCancel?: boolean;
  isNegative?: boolean;
}

export const SoloButton = (props: ButtonProps) => {
  const { text, onClick, errorText, error, disabled, isCancel, isNegative } = props;

  const { customStyles, customStylesError } = useGetCustomStyles();

  return (
    <div
      className={`main-button-container ${isCancel ? 'cancel' : ''} ${isNegative ? 'negative' : ''}`}
      style={{
        ...(!!isCancel && { backgroundColor: '#ADB3BC' })
      }}>
      <Button
        className='main-button'
        disabled={disabled}
        onClick={onClick}
        style={{
          ...(!!customStyles?.customStyling?.primaryColor && {
            backgroundColor: customStyles?.customStyling?.primaryColor
          })
        }}>
        {error ? errorText : text}
      </Button>
    </div>
  );
};

export const RemoveTagButton = styled.button`
  margin-left: 1.5rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
  display: inline-flex;
  color: rgba(194, 200, 208, 1);
  &:focus {
    color: #253e58;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
`;
